import styled from "styled-components";

export const AreaQr = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2.4rem;

  .moldura {
    background: #ffffff;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.elements};
    line-height: 0;
  }

  .rotulo-chave {
    margin-top: 15px;
    font-size: 12px;
    color: ${(props) => props.theme.colors.tertiary};
  }

  .chave {
    margin-top: 4px;
    font-family: monospace;
    font-size: 14px;
    letter-spacing: 1px;
    word-break: break-all;
    text-align: center;
    color: ${(props) => props.theme.colors.secondary};
    cursor: pointer;
  }
`;

export const Passos = styled.ol`
  text-align: left;
  color: ${(props) => props.theme.colors.tertiary};
  font-size: 14px;
  margin: 0 0 2.4rem 0;
  padding-left: 18px;

  li {
    margin-bottom: 6px;
  }
`;

export const Situacao = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2.4rem;
  font-size: 14px;

  .bolinha {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.primary};
  }
`;
